import {ProjectActions} from '../ActionTypes'
import {projectInitialState} from './projectInitalState'

const withSplitDownloads = function(projectDetails) {
    projectDetails.releases = projectDetails.downloads.filter(downloadable => downloadable.type === 'release')
    projectDetails.sources = projectDetails.downloads.filter(downloadable => downloadable.type === 'source')
    return projectDetails
}
export const projectReducer = function(state = projectInitialState, action) {
    const {CREATE, GET, VIEW, EDIT} = ProjectActions
    switch (action.type) {
    case CREATE.REQUEST:
        return {
            ...state,
            isUploading: true
        }

    case CREATE.SUCCESS:
        return {
            ...state,
            isUploading: false
        }

    case CREATE.ERROR:
        return {
            ...state,
            isUploading: false
        }

    case GET.REQUEST:
        return {
            ...state,
            isLoadingProjects: true
        }

    case GET.SUCCESS:
        return {
            ...state,
            projects: action.payload,
            isLoadingProjects: false
        }

    case GET.ERROR:
        return {
            ...state,
            isLoadingProjects: false,
            error: action.payload
        }

    case VIEW.REQUEST:
        return {
            ...state,
            isLoadingDetails: true
        }

    case VIEW.SUCCESS:
        return {
            ...state,
            projectDetails: withSplitDownloads(action.payload),
            isLoadingDetails: false
        }

    case VIEW.ERROR:
        return {
            ...state,
            isLoadingDetails: false,
            error: action.payload
        }

    case EDIT.REQUEST:
        return {
            ...state,
            isUpdatingProject: true
        }

    case EDIT.SUCCESS:
        if (state.projects.length !== 0) {
            const projectIndex = state.projects.findIndex(project => project.id === action.payload.id)
            state.projects[projectIndex] = action.payload
        }
        return {
            ...state,
            projectDetails: withSplitDownloads(action.payload),
            projects: state.projects,
            isUpdatingProject: false
        }

    case EDIT.ERROR:
        return {
            ...state,
            isUpdatingProject: false,
            error: action.payload
        }

    default: return state
    }
}

export default projectReducer
